const actions = {
  SET_STATE: 'leaders/SET_STATE',
  GET_DATA: 'leaders/GET_DATA',
  EDIT_LEADER: 'leaders/EDIT_LEADER',
  DELETE_LEADER: 'leaders/DELETE_LEADER',
  CREATE_LEADER: 'leaders/CREATE_LEADER',
  UPDATE_LEADERS_LIST: 'leaders/UPDATE_LEADERS_LIST',
  APPEND_LEADERS_LIST: 'leaders/APPEND_LEADERS_LIST',

  GET_LEADERS: 'leaders/GET_LEADERS',
  PAGE_CHANGED: 'leaders/PAGE_CHANGED',
  ROWS_CHANGED: 'leaders/ROWS_CHANGED',
}

export default actions
